module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('h3', [_vm._v("Takk for aksept!")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.po_number),
      expression: "po_number"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.po_number)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.send()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.po_number = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.localErrors.po_number) ? _c('span', {
    staticClass: "v-error",
    domProps: {
      "textContent": _vm._s(_vm.localErrors.po_number)
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.send()
      }
    }
  }, [_vm._v("Send inn")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("sentiment_very_satisfied")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Før vi ingangsetter"), _c('br'), _vm._v(" reparasjonsprosessen trenger vi et"), _c('br'), _vm._v(" PO-nummer")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-121821ae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./requests/assets/src/components/Opq/tags/AcceptOffer.vue
// module id = 105
// module chunks = 0